function colors(nightModeEnabled) {
  return {
    color: { color: nightModeEnabled ? '#fff' : '#000' },
    backgroundColor: { backgroundColor: nightModeEnabled ? '#fff' : '#171717' },
    borderColor: { borderColor: nightModeEnabled ? '#fff' : '#000' },
    borderTopColor: { borderTopColor: nightModeEnabled ? '#fff' : '#000' },
    
    colorInverted: { color: nightModeEnabled ? '#000' : '#fff' },
    backgroundColorInverted: { backgroundColor: nightModeEnabled ? '#000' : '#fff' },
    borderColorInverted: { borderColor: nightModeEnabled ? '#000' : '#fff' },
    borderTopColorInverted: { borderTopColor: nightModeEnabled ? '#000' : '#fff' },
  }
}

export default colors
